import { DashboardStatBlocks } from "@/app/Dashboard/Components/DashboardStatBlocks";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { BookingTable } from "@/app/Dashboard/Components/BookingTable";
import { BookingStatus, RelocationStatus, RelocationType } from "@/gql/graphql";
import { DashboardTaskList } from "@/app/Dashboard/Components/DashboardTaskList";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { metaQuery } from "@/app/Meta/GraphQL/metaQuery";
import { RelocationMultiTable } from "@/app/Relocations/Components/RelocationMultiTable";
import { DashboardPendingPaymentRequests } from "@/app/Dashboard/Components/DashboardPendingPaymentRequests";
import { DashboardPendingChangeRequests } from "@/app/Dashboard/Components/DashboardPendingChangeRequests";
import { useTranslations } from "use-intl";
import { GenericErrorBoundary } from "@/lib/Components/Layout/ErrorBoundary/ErrorBoundary";
import { useState } from "react";
import {
  RelocationTableState,
  defaultRelocationTableState,
} from "@/app/Relocations/Utils/relocationTableState";

export function DashboardScreen() {
  const t = useTranslations("dashboard");
  const { supplierId } = useGlobalSupplier();
  const { data } = useSuspenseGqlQuery(metaQuery, {});
  const [relocationTableState, setRelocationTableState] =
    useState<RelocationTableState>({
      ...defaultRelocationTableState,
      statuses: [RelocationStatus.Ready, RelocationStatus.Paused],
    });

  return (
    <FullPageScreen className="space-y-12 p-4">
      <GenericErrorBoundary>
        <DashboardStatBlocks />
      </GenericErrorBoundary>

      {data.meta.pending_payment_request_count ? (
        <DashboardPendingPaymentRequests />
      ) : null}

      {data.meta.pending_change_request_count ? (
        <DashboardPendingChangeRequests />
      ) : null}

      {data.meta.pending_task_count ? <DashboardTaskList /> : null}

      <BookingTable
        id="dashboard-pending-bookings"
        title={t("pendingBookings")}
        defaultState={{
          statuses: [
            BookingStatus.AwaitingConfirmation,
            BookingStatus.Accepted,
            BookingStatus.Vip,
          ],
        }}
      />

      <RelocationMultiTable
        tableId={"dashboard-relocations"}
        supplierId={supplierId ?? undefined}
        type={[RelocationType.Relocation]}
        state={relocationTableState}
        onStateChange={setRelocationTableState}
      />
    </FullPageScreen>
  );
}
